import { useMemo } from 'react';
import { useAppSelector } from '../../../hooks';
import FormBlock from 'components/formComponents/Layout/FormBlock';
import EnvelopeStripesIcon from '../../../images/envelope_w_stripes.svg?react';
import styles from './ConfirmationPage.module.scss';
import sanitize from 'sanitize-html';

const ExistingBankruptcyConfirmationPage = () => {
  const { pageTexts } = useAppSelector((state) => state.partyApplication);

  const texts = useMemo(() => {
    return pageTexts?.submitSection;
  }, [pageTexts]);

  return (
    <FormBlock
      title={
        texts?.existingBankruptcyConfirmationHeadline ??
        'Tack! Kontaktuppgifterna har skickats in'
      }
    >
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <EnvelopeStripesIcon />
        </div>
        <div
          className={styles.subSection}
          dangerouslySetInnerHTML={{
            __html: sanitize(
              texts?.existingBankruptcyConfirmationPreamble ?? ''
            ),
          }}
        />
      </div>
    </FormBlock>
  );
};

export default ExistingBankruptcyConfirmationPage;
